import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getFees = async () => {
  const { data } = await axios.get(`${api_base_url}/Fees`);
  //const { data } = await axios.get("https://localhost:44399/api/Entity");

  return data;
};

export const getFeesCount = async () => {
  return axios.get(`${api_base_url}/Fees/FeesCount`);
};

//Insert New LobType
export const addFees = async (newFeeData) => {
  const newLobTypeData = {};
  const { data } = await axios.post(`${api_base_url}/Fees`, {
    ...newFeeData[0],
  });
  return data;
};

// Update Fees
export const updateFees = async (updatedFeeData) => {
  await axios.put(
    `${api_base_url}/Fees/${updatedFeeData[0].commissionablePremiumId}`,
    updatedFeeData[0]
  );
};

export const searchFees = async (searchInputsData) => {
  const data = {
    carriers: searchInputsData.carrierName,
    state: searchInputsData.state,
    feeType: searchInputsData.feeType,
    policyTerm: searchInputsData.policyTerm.toString(),
    feeLevel: searchInputsData.feeLevel,
    effectiveDateFrom: searchInputsData.effectiveDateFrom,
    effectiveDateTo: searchInputsData.effectiveDateTo,
  };
  return await axios
    .post(`${api_base_url}/Fees/SearchFees`, data)
    .then((res) => res.data);
};

export const deletePolicyFees = async (ids) => {
  await axios.delete(`${api_base_url}/Fees/bulkDelete`, {
    data: ids,
  });
};

//Export policy fees data
export const exportPolicyFees = async (feeIds,filterStatus) => {
  var response = await axios.post(
    `${api_base_url}/Fees/ExportExcel/${filterStatus}`,feeIds,
    {
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    }
  );
  return response;
};